export default __webpack_public_path__ + "img/special-title_left_yellow.png?7b52";